
import { useState, useEffect } from 'react';
import TwitterHandleLinking from './TwitterHandleLinking';
import { supabase } from '@/integrations/supabase/client';
import { BroData } from '@/lib/broCode';

interface BroScoreOptimizationProps {
  walletAddress: string;
}

const BroScoreOptimization = ({ walletAddress }: BroScoreOptimizationProps) => {
  const [broData, setBroData] = useState<BroData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBroData = async () => {
      try {
        const { data, error } = await supabase
          .from('initiated_bros')
          .select('*')
          .eq('wallet_address', walletAddress.toLowerCase())
          .single();
        
        if (data && !error) {
          setBroData({
            id: data.id,
            wallet_address: data.wallet_address,
            brocode: data.brocode,
            brocode_prefix: data.brocode_prefix,
            rank: data.rank,
            bro_score: data.bro_score ?? 0,
            initiated: data.initiated ?? true,
            is_brometheus: data.is_brometheus ?? false,
            xp_cost: data.xp_cost ?? 0,
            created_at: data.created_at ?? new Date().toISOString(),
            twitter_handle: data.twitter_handle || undefined
          } as BroData);
        }
      } catch (error) {
        console.error('Error fetching bro data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBroData();
  }, [walletAddress]);

  const handleTwitterHandleLinked = (handle: string) => {
    if (broData) {
      setBroData({ ...broData, twitter_handle: handle });
    }
  };

  if (loading) {
    return <div className="text-tan/60">Loading...</div>;
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold text-tan">Optimize Your BroScore</h2>
      
      {broData && (
        <TwitterHandleLinking
          currentTwitterHandle={broData.twitter_handle}
          onHandleLinked={handleTwitterHandleLinked}
        />
      )}
      
      <div className="text-sm text-tan/80">
        <p>💡 <strong>Pro Tips:</strong></p>
        <ul className="list-disc list-inside mt-2 space-y-1">
          <li>Share your BroCode on Twitter: +15 BroScore</li>
          <li>Verify on Telegram: +15 BroScore</li>
          <li>Participate in wagers to earn more</li>
          <li>Link your Twitter to auto-track shares</li>
        </ul>
      </div>
    </div>
  );
};

export default BroScoreOptimization;
